import * as types from './types'
import storage from '@/plugins/storage'
export default {
  [types.SET_TEAM](state, teamProfile) {
    state.technicians = []
    state.teamLead = null
    state.team = teamProfile.team
    state.teamLead = {
      name: teamProfile.lead.fullName,
      code: teamProfile.lead.id
    }
    state.technicians.push(state.teamLead)
    // state.team.sid = team.SurrogateKey
    // state.team.name = team.Name
    // state.team.timezone = team.TimeZone
    // state.team.ContactId = team.ContactId
  },
  [types.SET_ID](state, sid) {
    if (sid !== undefined && sid !== null) {
      state.team.sid = sid
    }
  },
  [types.SET_ACTIVE_TAB](state, tab) {
    state.activeTab = tab
  },
  [types.SET_TEAM_TREE](state, data) {
    state.teamTree = data
  },
  [types.SET_TIME_ZONE_LIST](state, value) {
    state.selectedTimeZoneList = value
    state.timeZoneList = value
  },
  [types.SET_LANGUAGE_LIST](state, value) {
    state.selectedLanguageList = value
  },
  [types.SET_MAKE_LIST](state, value) {
    state.selectedMakeList = value
  },
  [types.SET_REGION_LIST](state, value) {
    state.selectedRegionList = value
  },
  [types.SET_SCAN_TYPE_CERTIFICATION_LIST](state, value) {
    state.selectedScanTypeCertificationList = value
  },
  [types.SET_STATE_CERTIFICATION_LIST](state, value) {
    state.selectedStateCertificationList = value
  },
  [types.SET_TEAM_AUTOCOMPLETE](state, data) { },
  [types.SET_SELECTED_ID](state, data) {
    state.selectedId = data.id
    state.selectedTeamId = ''
    state.selectedContactId = ''
    state.selectedTeamName = ''
    state.selectedTeamMemberName = ''
    state.selectedTimeZone = ''
    if (data.id === state.teamTree.Id) {
      state.selectedTeamId = state.teamTree.Id
      state.selectedTeamName = state.teamTree.Name
      state.selectedTimeZone = state.teamTree.TimeZone
    }
    if (state.selectedTeamName === '') {
      if (state.teamTree.Children !== undefined && state.teamTree.Children !== null) {
        if (state.teamTree.Children.length > 0) {
          for (let childLevel1 of state.teamTree.Children) {
            if (data.id === childLevel1.Id) {
              state.selectedTeamId = childLevel1.Id
              state.selectedTeamName = childLevel1.Name
              state.selectedTimeZone = childLevel1.TimeZone
              break
            }
            if (childLevel1.Children.length > 0) {
              for (let childLevel2 of childLevel1.Children) {
                if (data.id === childLevel2.Id) {
                  state.selectedTeamId = childLevel2.Id
                  state.selectedTeamName = childLevel2.Name
                  state.selectedTimeZone = childLevel2.TimeZone
                  break
                }
                if (childLevel2.Children.length > 0) {
                  for (let childLevel3 of childLevel2.Children) {
                    if (data.id === childLevel3.Id) {
                      state.selectedTeamId = childLevel3.Id
                      state.selectedTeamName = childLevel3.Name
                      state.selectedTimeZone = childLevel3.TimeZone
                      break
                    }
                    if (childLevel3.Children.length > 0) {
                      for (let childLevel4 of childLevel3.Children) {
                        if (data.id === childLevel4.Id) {
                          state.selectedTeamId = childLevel4.Id
                          state.selectedTeamName = childLevel4.Name
                          state.selectedTimeZone = childLevel4.TimeZone
                          break
                        }
                        if (childLevel4.Children.length > 0) {
                          for (let childLevel5 of childLevel4.Children) {
                            if (data.id === childLevel5.Id) {
                              state.selectedTeamId = childLevel5.Id
                              state.selectedTeamName = childLevel5.Name
                              state.selectedTimeZone = childLevel5.TimeZone
                              break
                            }
                            if (childLevel5.Children.length > 0) {
                              for (let childLevel6 of childLevel5.Children) {
                                if (data.id === childLevel6.Id) {
                                  state.selectedTeamId = childLevel6.Id
                                  state.selectedTeamName = childLevel6.Name
                                  state.selectedTimeZone = childLevel6.TimeZone
                                  break
                                }
                              }
                            }
                          }
                        }
                      }
                    }
                  }
                }
              }
            }
          }
        }
      }
    }
  },
  [types.SET_SELECTED_CONTACT_ID](state, id) {
    state.selectedContactId = id
    state.teamMemberProfile = {}
  },
  [types.SET_TEAM_LEAD](state, lead) {
    state.teamLead = lead
  },
  [types.SET_TEAM_MEMBER_IDS](state, data) {
    state.teamMemberIds = data
  },
  [types.SET_TEAM_MEMBERS](state, data) {
    state.teamMembers = data
  },
  [types.SET_SELECTED_TEAM_MEMBER_ID](state, data) {
    if (data != null) {
      state.selectedTeamId = data.TeamId
      state.selectedTeamMemberId = data.ContactId
      state.selectedTeamMemberName = data.TeamMemberName
      state.selectedTeamMemberUsername = data.Username
    }
  },
  [types.SET_TEAM_NAME](state, team) {
    state.team.name = team.name
  },
  [types.SET_MEMBER_ID](state, id) {
    state.teamMemberId = id
  },
  [types.SET_SEARCH_TERM](state, text) {
    state.searchTerm = text
    storage.session.setItem(types.SESSION_SEARCH_TERM, text)
  },
  [types.SET_PAGE_SIZE](state, pageSize) {
    state.pageSize = pageSize
    storage.session.setItem(types.SESSION_PAGE_SIZE, pageSize)
  },
  [types.SET_MEMBER_PROFILE](state, data) {
    if (data.length > 0) {
      // console.log('SET_MEMBER_PROFILE data', data)
      state.teamMemberProfile = data[0]
    } else {
      state.teamMemberProfile = {}
    }
  },
  [types.SET_SELECTED_MEMBER_PROFILE](state, data) {
    state.selectedTeamMemberProfile = data
    // console.log('SET_SELECTED_MEMBER_PROFILE - state', state, 'data', data)
  },
  [types.SET_MEMBER_PROFILE_ID](state, data) {
    state.teamMemberProfile.id = data
    state.teamMemberProfileId = data
  },
  [types.SET_TEAM_MEMBER_ATTRIBUTES](state, data) {
    // look for unique ids
    state.uniqueAttributes = []
    state.attributes = []
    // console.log('mutations - set_team_member_attributes', data)
    var attrList = []
    var uniqueNames = []
    var uniqueIds = []
    for (var i = 0; i < data.length; i++) {
      var attr0 = {
        AttrId: data[i].Id,
        AttrName: data[i].Name,
        AttrValueId: data[i].Id,
        AttrValue: data[i].Value,
        AttrSelected: data[i].Selected
      }
      attrList.push(attr0)

      if (uniqueIds.indexOf(data[i].Id) === -1) {
        uniqueIds.push(data[i].Id)
        var attr1 = {
          AttrId: data[i].Id,
          AttrName: data[i].Name
        }
        uniqueNames.push(attr1)
      }
    }

    // ScanType Id is 9
    const scanTypeFilter = x => x.AttrId === '9'

    // Scan types need to pre-populated as selected
    const scanTypeAttributes = attrList.filter(scanTypeFilter)
    if (scanTypeAttributes.every(x => x.AttrSelected === 0)) {
      scanTypeAttributes.forEach(x => { x.AttrSelected = 1 })
    }

    // To prevent closing a selection container
    const scanTypeGroup = uniqueNames.find(scanTypeFilter) || {}
    scanTypeGroup.keepSlectionOpened = true

    state.isCertificationIddisabled = attrList.filter(x => x.AttrId === '10' && x.AttrSelected === 1).length === 0

    state.attributes = attrList
    state.uniqueAttributes = uniqueNames
    // console.log('set_team_member_attributes - attrList', attrList)
    // console.log('set_team_member_attributes - uniqueNames', uniqueNames)
  },
  [types.SET_MEMBER_ATTRIBUTE_OPTIONS](state, data) {
    state.memberAttributeOptions = JSON.parse(data)
    state.attributes = []
    var obj = state.memberAttributeOptions
    if (obj != null) {
      for (let o of obj) {
        o = JSON.parse(o)
        state.attributes.push(o['Value'])
      }
    }

    // state.attributes = [...new Set(state.memberAttributeOptions.map(item => item.AttrName))] // read through the attribute names listed and get unique values
    var parentObj = [] // create a container to build the new object needed for the list of attributes
    for (var i in state.attributes) {
      parentObj.push({
        AttrName: state.attributes[i] // generate an array of items with the name "AttrName" with a string value to be sent to the multiselect component
      })
    }
    state.attributes = parentObj // assign the new object to replace the object being used
  },
  [types.SET_MEMBER_ATTRIBUTE_SELECTED_VALUES_TO_EMPTY](state, data) {
    // console.log('set_member_attribute_selected_values_to_empty', state)
    if (state.memberAttributeSelectedValues.length > 0) {
      state.memberAttributeSelectedValues = []
      state.attributes = []
    }
  },
  [types.SET_MEMBER_ATTRIBUTE_SELECTED_VALUES](state, data) {
    var currentList = []
    if (state.memberAttributeSelectedValues.length > 0) {
      if (state.memberAttributeSelectedValues[0] !== 'undefined') {
        currentList = state.memberAttributeSelectedValues
      }
    }

    if ((currentList[0] === undefined) && (data[0] !== undefined)) {
      currentList.push(data[0])
    }

    for (var k = 0; k < data.length; k++) {
      var idx = -1
      for (var j = 0; j < currentList.length; j++) {
        if (currentList[j].attributeValue === data[k].attributeValue) {
          idx = j
        }
      }

      if (idx === -1) {
        currentList.push(data[k])
      }
    }

    if (data[0] === 'remove') {
      for (var m = 0; m < currentList.length; m++) {
        if (currentList[m].attributeValue === data[1]) {
          currentList.splice(m, 1)
        }
      }
      if (currentList[currentList.length - 1] === 'remove') {
        currentList.splice(currentList.length - 1)
      }
    }

    state.memberAttributeSelectedValues = currentList
  },
  [types.SET_MEMBER_ATTRIBUTE_LABEL](state, data) {
    state.memberAttributeLabel = data
  },
  [types.SET_TECHNICIANS](state, data) {
    console.log('SET_TECHNICIANS - mutations', 'data', data, state)
    state.technicians = data
  },
  [types.SET_PROFILE_TEAM_LEAD](state, data) { },
  [types.SET_STATE_CERTIFICATION_ID](state, data) { },
  [types.SET_STATE_CERTIFICATION_IDS_LIST](state, data) {
    state.stateCertificationIds = { ...data }
  },
  [types.SET_STATE_CERTIFICATION_ID_TXT_ISDISABLED](state, data) {
    state.isCertificationIddisabled = data
  }
}



// WEBPACK FOOTER //
// ./src/store/modules/admin/teams/mutations.js